import { Box, Flex, Image, Switch, Text, useToast } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { fetchCallProviders, updateCallProviderStatus } from "../../../../store/callProviderSlice";
import { useDispatch, useSelector } from "react-redux";
import { useSocket } from "../../../Socket";

const ICONS = {
  Zoom: "/assets/icons/zoom-icon.png",
  VideoSDK: "/assets/icons/videosdk-icon.png",
};

export default function CallProviders() {
  const dispatch = useDispatch();
  const { socket } = useSocket();
  const { providers } = useSelector((state) => state.callProvider);
  const toast = useToast();
  const [localProviderState, setLocalProviderState] = useState({});

  useEffect(() => {
    dispatch(fetchCallProviders());
  }, [dispatch]);

  useEffect(() => {
    if (providers && providers.length) {
      const initialState = {};
      providers.forEach((p) => {
        initialState[p._id] = p.enabled;
      });
      setLocalProviderState(initialState);
    }
  }, [providers]);

  const toggleProvider = async (providerId, providerName) => {
    const newEnabledState = !localProviderState[providerId];

    setLocalProviderState({
      ...localProviderState,
      [providerId]: newEnabledState,
    });

    try {
      await dispatch(
        updateCallProviderStatus({
          providerId,
          payload: { enabled: newEnabledState },
          socket
        })
      );

      toast({
        title: `${providerName} ${newEnabledState ? "enabled" : "disabled"} successfully`,
        status: "success",
        duration: 3000,
        isClosable: true,
        position: "top-right",
      });

      dispatch(fetchCallProviders());
    } catch (error) {
      toast({
        title: `${error}`,
        status: "error",
        duration: 3000,
        isClosable: true,
        position: "top-right",
      });
      console.error("Error updating provider:", error);

    }
  };

  return (
    <Box
      background={"#e5e5fe"}
      borderRadius="md"
      padding="14px"
      height={"auto"}
      width={"100%"}
    >
      <Box marginBottom="4">
        <Text fontWeight="bold" fontSize="xl">
          Call Provider
        </Text>
        <Text fontSize="sm" color="gray.600">
          Toggle to activate or deactivate call provider integration.
        </Text>
      </Box>

      <Flex direction="column" gap={4}>
        {providers.map((provider) => (
          <Flex
            key={provider._id}
            justify="space-between"
            align="center"
            background="white"
            padding="10px"
            borderRadius="md"
          >
            <Flex align="center" gap={4}>
              <Image
                src={ICONS[provider.name] || "/assets/icons/default.png"}
                alt={provider.name}
                boxSize="40px"
                objectFit="contain"
                borderRadius="full"
                background="#eee"
              />
              <Box>
                <Text fontWeight="bold">{provider.name}</Text>
                <Text fontSize="sm" color="gray.500">
                  Enable {provider.name} integration
                </Text>
              </Box>
            </Flex>
            <Switch
              size="lg"
              isChecked={localProviderState[provider._id]}
              onChange={() => toggleProvider(provider._id, provider.name)}
            />
          </Flex>
        ))}
      </Flex>
    </Box>
  );
}
